import { render, staticRenderFns } from "./ReportToWidget.vue?vue&type=template&id=033a3fae"
import script from "./ReportToWidget.vue?vue&type=script&lang=js"
export * from "./ReportToWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports